import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, Slider, Typography } from "@material-ui/core";
import { CheckCircle, RadioButtonUnchecked } from "@material-ui/icons";
import GetAppIcon from "@material-ui/icons/GetApp";
import ErrorIcon from "@material-ui/icons/Error";
import { translate as t } from "../../../../translate/localization";
import CobeeButton from "../../../../../app/components/CobeeButton";
import { MonetaryAmount } from "../../../../../app/domain/monetary-amount";
import useStyles from "../../styles";

export default function ModalityConfig({
  modalityId,
  name,
  enabled,
  brochures,
  capitalConfigs,
  coverageDescription,
  onChange,
  onToggle,
  defaultSlideValue,
}) {
  const {
    divider,
    row,
    sliderContainer,
    infoIcon,
    radio,
    radioText,
    activeRadioText,
    checkedRadio,
  } = useStyles();

  const [value, setValue] = useState(defaultSlideValue);
  const [isEnabled, setIsEnabled] = useState(enabled);

  return (
    <Grid key={modalityId} item xs={12} container>
      <Grid item xs={6} container>
        <Typography variant="h6">{name}</Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        justify="flex-end"
        alignItems="center"
        onClick={() => {
          setIsEnabled(!isEnabled);
          onToggle();
        }}
      >
        {isEnabled ? (
          <CheckCircle className={`${radio} ${checkedRadio}`} />
        ) : (
          <RadioButtonUnchecked className={radio} />
        )}
        <Typography
          variant="body2"
          className={`${isEnabled ? activeRadioText : radioText}`}
        >
          {t(`benefits-section.activated`)}
        </Typography>
      </Grid>
      <Grid item xs={12} container>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={brochures?.[0].url} target="__blank">
          <CobeeButton styleType="uncontained">
            <GetAppIcon />
            {brochures?.[0].title}
          </CobeeButton>
        </a>
      </Grid>
      <Grid item xs={12} container className={row}>
        <Typography variant="body2">{coverageDescription}</Typography>
      </Grid>
      <Grid item xs={12} container className={row}>
        <Typography variant="body2">
          {t("benefits-section.life-insurance-benefit.config-modal-tooltip-1")}
        </Typography>
      </Grid>
      <Grid item xs={12} container justify="center">
        <Grid item xs={6} className={sliderContainer}>
          <Slider
            aria-labelledby="discrete-slider"
            step={1}
            min={0}
            max={capitalConfigs.length}
            value={value}
            onChange={(e, newValue) => {
              setValue(newValue);
              onChange({
                modalityId,
                value: newValue,
              });
            }}
            marks={[
              {
                value: 0,
                label: (
                  <Grid item container>
                    <Grid item xs={12} container justify="center">
                      <Typography variant="body2">0 EUR</Typography>
                    </Grid>
                    <Grid item xs={12} container justify="center">
                      <Typography variant="body2">
                        {t("common-messages.the-company-does-not-subsidize")}
                      </Typography>
                    </Grid>
                  </Grid>
                ),
              },
              ...capitalConfigs.map(({ type, fixedAmount }, i) => ({
                value: i + 1,
                label: (
                  <Grid item container>
                    <Grid
                      item
                      xs={12}
                      container
                      justify="center"
                      alignItems="center"
                      direction="column"
                    >
                      <Typography variant="body2">{`${
                        type === "fixed"
                          ? MonetaryAmount.ofCurrency(
                              fixedAmount
                            ).prettifyMoney({})
                          : `100%`
                      }`}</Typography>
                      <Typography variant="body2">
                        {t(
                          "benefits-section.life-insurance-benefit.of-capital"
                        )}{" "}
                        {i + 1}
                      </Typography>
                    </Grid>
                  </Grid>
                ),
              })),
            ]}
          />
        </Grid>
      </Grid>
      {value === 0 && (
        <Grid item xs={12} container className={row} alignItems="center">
          <ErrorIcon className={infoIcon} />
          <Typography variant="body2">
            {t(
              "benefits-section.life-insurance-benefit.config-modal-tooltip-2"
            )}
            .
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} className={divider} />
    </Grid>
  );
}

ModalityConfig.defaultProps = {
  enabled: false,
  defaultSlideValue: 0,
};

ModalityConfig.propTypes = {
  modalityId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  enabled: PropTypes.bool,
  brochures: PropTypes.array.isRequired,
  capitalConfigs: PropTypes.array.isRequired,
  coverageDescription: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  defaultSlideValue: PropTypes.number,
};
